import PropTypes from 'prop-types';
import React from 'react';
// @mui/material components
import Environments from '@mui/icons-material/SettingsInputComponent';
import InputAdornment from '@mui/material/InputAdornment';
import withStyles from '@mui/styles/withStyles';

// core components
import CustomInput from 'components/CustomInput/CustomInput.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js';

const style = {
  infoText: {
    fontWeight: '300',
    margin: '10px 0 30px',
    textAlign: 'center',
  },
  ...customSelectStyle,
};

class Step4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productionCount: 0,
      productionCountState: '',
      testCount: 0,
      testCountState: '',
    };
  }
  sendState() {
    return this.state;
  }
  // function that verifies if a string has a given length or not
  verifyMinMax(value, min, max) {
    if (value >= min && value <= max) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, min, max) {
    var value = null;
    switch (type) {
      case 'number':
        value = parseInt(event.target.value);
        if (this.verifyMinMax(value, min, max)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: value });
  }
  isValidated() {
    if (
      this.state.productionCountState === 'success' &&
      this.state.testCountState === 'success'
    ) {
      return true;
    } else {
      if (this.state.productionCountState !== 'success') {
        this.setState({ productionCountState: 'error' });
      }
      if (this.state.testCountState !== 'success') {
        this.setState({ testCountState: 'error' });
      }
    }
    return false;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            Specify the number of starting environments for the customer
          </h4>
        </GridItem>
        <GridItem xs={12} sm={4}>
          <CustomInput
            success={this.state.productionState === 'success'}
            error={this.state.productionState === 'error'}
            labelText={
              <span>
                Production environments <small>(required)</small>
              </span>
            }
            id='productionCount'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) =>
                this.change(event, 'productionCount', 'number', 0, 10),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Environments className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
              type: 'number',
              autoComplete: 'off',
              min: 0
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={4}>
          <CustomInput
            success={this.state.testState === 'success'}
            error={this.state.testState === 'error'}
            labelText={
              <span>
                Test environments <small>(required)</small>
              </span>
            }
            id='testCount'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) =>
                this.change(event, 'testCount', 'number', 0, 10),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Environments className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
              type: 'number',
              autoComplete: 'off',
              min: 0
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Step4.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(style)(Step4);
